import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const AtMentionLockedIcon = (props: IconProps) => (
  <Icon width="24px" height="24px" viewBox="0 0 24 24" {...props}>
    <mask
      id="mask0_845_17216"
      maskUnits="userSpaceOnUse"
      x="-2"
      y="1"
      width="24"
      height="24"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 25C16.6274 25 22 19.6274 22 13C22 12.6632 21.9861 12.3297 21.9589 12H16C14.8954 12 14 11.1046 14 10V4C14 3.18648 14.4857 2.4864 15.183 2.17395C13.6141 1.42148 11.8563 1 10 1C3.37258 1 -2 6.37258 -2 13C-2 19.6274 3.37258 25 10 25Z"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_845_17216)">
      <path d="M10.5 5C5.256 5 1 9.256 1 14.5C1 19.744 5.256 24 10.5 24H15.25V22.1H10.5C6.377 22.1 2.9 18.623 2.9 14.5C2.9 10.377 6.377 6.9 10.5 6.9C14.623 6.9 18.1 10.377 18.1 14.5V15.8585C18.1 16.609 17.4255 17.35 16.675 17.35C15.9245 17.35 15.25 16.609 15.25 15.8585V14.5C15.25 11.878 13.122 9.75 10.5 9.75C7.878 9.75 5.75 11.878 5.75 14.5C5.75 17.122 7.878 19.25 10.5 19.25C11.811 19.25 13.008 18.718 13.863 17.8535C14.4805 18.699 15.5445 19.25 16.675 19.25C18.5465 19.25 20 17.73 20 15.8585V14.5C20 9.256 15.744 5 10.5 5ZM10.5 17.35C8.923 17.35 7.65 16.077 7.65 14.5C7.65 12.923 8.923 11.65 10.5 11.65C12.077 11.65 13.35 12.923 13.35 14.5C13.35 16.077 12.077 17.35 10.5 17.35Z" />
    </g>
    <path d="M22.5 4.125V2.75C22.5 1.2375 21.15 0 19.5 0C17.85 0 16.5 1.2375 16.5 2.75V4.125C15.675 4.125 15 4.74375 15 5.5V9.625C15 10.3813 15.675 11 16.5 11H22.5C23.325 11 24 10.3813 24 9.625V5.5C24 4.74375 23.325 4.125 22.5 4.125ZM18 4.125V2.75C18 1.99375 18.675 1.375 19.5 1.375C20.325 1.375 21 1.99375 21 2.75V4.125H18Z" />
  </Icon>
);

export default memo(AtMentionLockedIcon);
